/**
 * 暂时不需要
 * @param taskId
 * @returns {Promise<unknown>}
 */
export default function nextTask({taskId}) {
    return new Promise((resolve, reject)=>{
        resolve();
    })
}
